import { Link } from "react-router-dom";
import { Seo } from "@/components/site/Seo";
import { PageHero } from "@/components/site/PageHero";

export default function NotFound() {
  return (
    <>
      <Seo title="Page not found | Easy Handyman Services" description="The page you were looking for could not be found." />
      <PageHero testId="notfound-hero" eyebrow="404" lines={["This page has", "gone missing."]} intro="Let's get you back home.">
        <Link to="/" data-testid="notfound-home-link" className="mt-10 inline-flex rounded-full bg-[var(--green)] px-7 py-3.5 font-semibold text-white">Back to home</Link>
      </PageHero>
    </>
  );
}
